// extracted by mini-css-extract-plugin
module.exports = {"empty-message":"style_empty-message__1CpI6"};